<template>
  <IQOS
    :title="$t('stats.clients.title')"
    class="bills-container iqos-empty"
    boxClass="container-box p-0 clients-table-box"
  >
    <div class="search-container">
      <BaseInput class="search-input" :placeholder="$t('stats.clients.search')" v-model="search" :readonly="false" />
      <button class="export-button" @click="exportToCsv">{{$t('stats.clients.export')}}</button>
      <button class="export-button" @click="showImportModal">{{$t('stats.clients.import')}}</button>
    </div>
    <div class="bills-box">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{$t('stats.clients.name')}}</th>
            <th scope="col">{{$t('stats.clients.phone')}}</th>
            <th scope="col">{{$t('stats.clients.address')}}</th>
            <th scope="col" v-if="showBonusBalance">{{$t('stats.clients.bonus')}}</th>
            <th scope="col">{{$t('stats.clients.averange')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in filteredClients" :key="item._id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.phone }}</td>
            <td>{{ item.address }}</td>
            <td v-if="showBonusBalance">{{ item.bonus_balance }} {{ currency.iso_code }}</td>
            <td>{{ item.average_check }} {{ currency.iso_code }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <ImportClientsModal 
      @success="onSuccessfulImport"
      @close="import_modal = false"
      v-if="import_modal"/>
  </IQOS>
</template>

<style scoped>
div {
  width: inherit;
}

th {
  text-align: center;
  color: #a4a3a1;
}

.bills-box {
  width: 122vh;
}

.table th {
  border-top: 0 !important;
}

thead th {
  position: sticky;
  top: 0;
  background: #1d1d1d;
}

td {
  text-align: center;
  color: #ededed;
}

td img {
  height: 3vh;
  width: auto;
}

/* td span {
  color: #ededed;
  font-size: 1.8vh;
  background: #262626;
} */

td span.preorder {
  background: #ffd2a8;
  border-radius: 0.7vh;
  color: #1d1d1d;
  padding: 0.5vh 1vh;
}

td span.delivery {
  background: #cbd9e6;
  border-radius: 0.7vh;
  color: #1d1d1d;
  padding: 0.5vh 1vh;
}

.text-red {
  color: #e2223b;
}
.text-green {
  color: #129b81;
}

.table th {
  padding: 2vh;
}

th,
td {
  font-size: 2vh;
}

.bills-container {
  width: 100%;
  margin-top: 5.4vh;
 
  position: relative;
}

.search-container {
  position: absolute;
  top: -0.5vh;
  right: 0;

  display: flex;
}

.clients-table-box {
  position: relative;
}

.search-input {
  text-align: left;
  padding-left: 0.5vh;
}

.export-button {
  font-size: 2vh;
  outline: none;
  border: 1px solid #a4a4a4;
  background: transparent;
  color: #a4a4a4;
  border-radius: 0.5vh;
  margin-left: 2vh;
  padding: 0 2vh;
  cursor: pointer;
}
</style>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackInput from "@/components/BlackInput.vue";

import ImportClientsModal from '@/components/stats/ImportClientsModal.vue'

import {saveAs} from 'file-saver'

export default {
  data() {
    return {
      search: null,
      import_modal: false
    };
  },
  props: {
    clients: Array
  },
  components: {
    IQOS,
    BlackInput,
    ImportClientsModal
  },
  methods: {
    exportToCsv() {
      let csv = `№,Ім'я,Номер телефону,Адреса,Бонусний рахунок,Середній чек\n`;

      this.filteredClients.forEach((item,index) => {
        const fields = [
          index+1,
          item.name,
          item.phone,
          item.address || '?',
          item.bonus_balance || 0,
          item.average_check || 0
        ];

        csv += fields.map(f => `"${f}"`).join(",") + "\n";
      });

      const blob = new Blob([csv], {
        type: "text/csv"
      });

      saveAs(blob, `clients-${Date.now()}.csv`);
    },
    showImportModal() {
      this.import_modal = true;
    },
    onSuccessfulImport() {
      this.$emit('imported');
      this.import_modal = false;
    }
  },
  computed: {
    filteredClients() {
      if (!this.search) return this.clients;

      const query = this.search.toLowerCase();

      return this.clients.filter(client => {
        return (
          client.name.toLowerCase().includes(query) ||
          client.phone.toLowerCase().includes(query) ||
          client.address.toLowerCase().includes(query)
        );
      });
    },
    cafe() {
      return this.$store.state.cafe;
    },
    showBonusBalance() {
      return this.cafe.loyalty && this.cafe.loyalty.cashback_percent && this.cafe.loyalty.terms_agreed;
    },
    currency() {
      return this.$store.state.currency;
    }
  },
  filters: {
    capitalize(str) {
      return str.substring(0, 1).toUpperCase() + str.substring(1);
    }
  }
};
</script>